module.exports = __webpack_public_path__ + "static/media/avalia-logo.76e4b748.png";